import { __awaiter } from "tslib";
import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from '@/router/routes';
import Store from '@/store/index';
import { updateChaportPageContext } from '@/utils/chaport';
Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});
router.beforeEach((to, from, next) => __awaiter(void 0, void 0, void 0, function* () {
    let userInfoResponse = null;
    if (!Store.getters['user/getIsAuthenticated']) {
        userInfoResponse = yield Store.dispatch('user/loadUser');
        yield Store.dispatch('user/loadAccessInfo');
        // await Store.dispatch('screener/actionAccessesScreener')
    }
    if (Store.getters['popupModule/getPopupIsOpened'])
        Store.commit('popupModule/setClosed');
    Store.dispatch('popupModule/setFirstClosing', true);
    const itErrorPage = to.name === 'errorPage';
    const showDocumentsNotification = (userInfoResponse === null || userInfoResponse === void 0 ? void 0 : userInfoResponse.success) && !itErrorPage;
    if (showDocumentsNotification) {
        Store.dispatch('user/documentsNotification', userInfoResponse === null || userInfoResponse === void 0 ? void 0 : userInfoResponse.data.docs);
    }
    if ((to.name === 'screener' || to.name === 'terminal') && !Store.getters['screener/getAccessesScreener']) {
        next('/');
    }
    next();
}));
router.afterEach((to, from) => {
    var _a;
    if ((_a = to.meta) === null || _a === void 0 ? void 0 : _a.title) {
        document.title = to.meta.title;
    }
    window.ym(89268028, 'hit', to.path, {
        title: document.title,
        referer: new URL(from.path, window.location.origin)
    });
    window.ym(93312770, 'hit', to.path, {
        title: document.title,
        referer: new URL(from.path, window.location.origin)
    });
    updateChaportPageContext(document.title, to.fullPath);
});
export default router;
